import React from "react";
import { Modal, Button, Form } from "react-bootstrap";
import CancelButton from "presentation/components/buttons/cancel";

import { goTo, handleChange, handleResultData } from "presentation/utils/functions/generic";

import courseDisciplinesService from "presentation/services/course-disciplines";

import PageLoadingIndicator from "presentation/components/page-loading-indicator";
import PageAlert from "presentation/components/page-alert";

class SelectDisciplineEvaluationModal extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            loading: false,
            disciplines: []
        };

    }

    componentDidMount() {
        this.loadData();
    }


    defaultSubmit = async () => {

        let { classroomId, academicPeriodId, courseId, component } = this.props;
        let { form } = component.state;

        this.setState({ loading: true, error: '' });

        let hasInvalidInfo = !form.disciplineId;
        if (hasInvalidInfo) {
            this.setState({ loading: false, error: true, message: "Por favor, selecione um disciplina" });
        } else {
            const { disciplines } = this.state;

            const item = disciplines.find(x => x.disciplineId == form.disciplineId);

            const displayName = item.discipline.displayName ?? "";

            let targetUrl = `/turmas/${classroomId}/lancamento-de-notas/disciplina`;
            let destination = { pathname: targetUrl, state: { disciplineId: form.disciplineId, disciplineName: displayName, courseId: courseId, academicPeriodId: academicPeriodId } };
            goTo(destination, component);
        }
    };

    loadData = async () => {
        const { academicPeriodId, courseId } = this.props;
        this.setState({ loading: true });

        let disciplines = [];
        await courseDisciplinesService.search({ courseId: [parseInt(courseId)], academicPeriodId: [parseInt(academicPeriodId)] }).then((result) => {
            disciplines = handleResultData(result);
        });


        this.setState({ loading: false, disciplines: disciplines });
    }

    render() {
        let { show, onClose, classroomName, onSubmit, component } = this.props;
        let { loading, error, message, disciplines } = this.state;
        const { form } = component.state;

        const hasSelection = form?.disciplineId || false;

        const modalSubmit = onSubmit ? onSubmit : this.defaultSubmit;

        return (
            <Modal size="lg" backdrop="static" show={show || false} onHide={onClose}>
                <Modal.Header closeButton>
                    <Modal.Title>{classroomName} / Lançamento de notas por disciplina</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    {loading === true && <PageLoadingIndicator loadingText={"Carregando informações..."} />}
                    {loading === false && error === true && <PageAlert className="m-b-20" message={"Erro"} description={message} type="danger" />}
                    {loading === false && (
                        <>
                            <div className="form mt-2">
                                <Form.Label htmlFor="disciplineId">Disciplina</Form.Label>
                                <Form.Select
                                    aria-label="Disciplina"
                                    id="disciplineId"
                                    name="disciplineId"
                                    defaultValue={form?.disciplineId || undefined}
                                    onChange={async (e) => await handleChange(e, component)}
                                    aria-describedby="disciplineIddHelpBlock"
                                    required
                                >
                                    <option value={-9999}>Selecione uma disciplina</option>
                                    {disciplines.map((e, i) => { return <option key={e.disciplineId} value={e.disciplineId}>{e.discipline.displayName}</option> })}
                                </Form.Select>
                                <Form.Text id="disciplineIdHelpBlock" muted>
                                    Escolha uma disicplina para realizar o lançamento de notas
                                </Form.Text>
                            </div>
                        </>
                    )}
                </Modal.Body>
                <Modal.Footer>
                    <CancelButton
                        containerProps={{
                            disabled: loading,
                            onClick: onClose
                        }}
                    />
                    <Button disabled={loading || !hasSelection} variant="success" onClick={() => modalSubmit()}>
                        Iniciar
                    </Button>
                </Modal.Footer>
            </Modal>
        );
    };
}

export default SelectDisciplineEvaluationModal;